// extracted by mini-css-extract-plugin
export default {"container":"services_container__gi6cG","card_container":"services_card_container__Ewptq","wave_left":"services_wave_left__7Kvuj","wave_right":"services_wave_right__cR7ZU"};